import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/api/queryKeys";
import type { DataResponse, TopSolidImportResponse } from "@/api/schemas";

/**
 * POST /api/import/topsolid/do-zakazky/{id} — import TopSolid CSV do
 * existujúcej zákazky ako výrobná varianta (realita výroby).
 */
export function useImportTopsolidDoZakazky(): UseMutationResult<
  DataResponse<TopSolidImportResponse>,
  Error,
  { zakazkaId: string; file: File; vyrobne_cislo?: string }
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ zakazkaId, file, vyrobne_cislo }) => {
      const formData = new FormData();
      formData.append("file", file);
      if (vyrobne_cislo) formData.append("vyrobne_cislo", vyrobne_cislo);
      const { data } = await api.post<DataResponse<TopSolidImportResponse>>(
        `/import/topsolid/do-zakazky/${zakazkaId}`,
        formData,
      );
      return data;
    },
    onSuccess: (_data, { zakazkaId }) => {
      qc.invalidateQueries({ queryKey: queryKeys.zakazky.detail(zakazkaId) });
      qc.invalidateQueries({ queryKey: queryKeys.zakazky.lists() });
    },
  });
}
